module.exports = __webpack_public_path__ + "media/img/event/Scholarships2u_virtual-booth-d58b077cd150f41f1964ec3c24fe12e6.svg";